import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/common/assets/logo.svg'
import _imports_1 from '@/common/assets/icon/back.svg'


const _withScopeId = n => (_pushScopeId("data-v-c4af4e5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper-auth p-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = { class: "header mb-1" }
const _hoisted_4 = { class: "sub-header" }
const _hoisted_5 = { class: "flex items-center content-login" }
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onChange"]
const _hoisted_9 = {
  key: 0,
  class: "text-left error mt-2"
}
const _hoisted_10 = { class: "phone-description" }
const _hoisted_11 = { class: "flex justify-center items-center" }
const _hoisted_12 = {
  key: 1,
  class: "wrapper-auth p-4"
}
const _hoisted_13 = { class: "logo flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-img-otp" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_17 = { class: "header" }
const _hoisted_18 = { class: "sub-header-otp" }
const _hoisted_19 = { class: "phone" }
const _hoisted_20 = { class: "mt-5 flex flex-col items-center" }
const _hoisted_21 = { class: "flex items-center resend-title" }
const _hoisted_22 = { class: "countdown flex items-center" }
const _hoisted_23 = { class: "mr-1" }
const _hoisted_24 = { class: "flex justify-center items-center" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_vue_countdown = _resolveComponent("vue-countdown")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_modal_breakpoint = _resolveComponent("modal-breakpoint")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          (!_ctx.openOtp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.t("user-login-page.header")), 1),
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.t("user-login-page.sub-header")), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Form, {
                    onSubmit: _ctx.handleRequestCode,
                    class: "form-request",
                    ref: "formRequest",
                    "validation-schema": _ctx.schemaRequestCode
                  }, {
                    default: _withCtx(({ errors }) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_ion_label, { id: "select-country" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              class: "flag",
                              src: require('@/common/assets/icon/profile/' + _ctx.getFlag())
                            }, null, 8, _hoisted_7),
                            _createTextVNode("+ " + _toDisplayString(_ctx.getCountryNumber()), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Field, {
                          name: "phone_number",
                          modelValue: _ctx.formValues.phone_number,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formValues.phone_number) = $event))
                        }, {
                          default: _withCtx(({ handleChange }) => [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              inputmode: "numeric",
                              onChange: handleChange,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValues.phone_number) = $event))
                            }, null, 40, _hoisted_8), [
                              [_vModelText, _ctx.formValues.phone_number]
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      (errors.phone_number)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errors.phone_number), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.t("user-login-page.title.phone")), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ion_button, {
                          class: "w-full",
                          type: "submit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("user-login-page.title.continue")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit", "validation-schema"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.openOtp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "go-back",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _hoisted_15),
                  _hoisted_16
                ]),
                _createElementVNode("h1", _hoisted_17, _toDisplayString(_ctx.t("user-login-page.header-otp")), 1),
                _createElementVNode("label", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_ctx.t("user-login-page.sub-header-otp")) + " ", 1),
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.hidePhoneNumber(_ctx.phoneNumber)), 1)
                ]),
                _createVNode(_component_Form, {
                  class: "form-confirm",
                  ref: "formConfirm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_otp_input, {
                      class: "flex justify-center items-center",
                      ref: "otpInput",
                      "input-classes": "otp-input-custom",
                      separator: "",
                      "num-inputs": 6,
                      "should-auto-focus": true,
                      "is-input-num": true,
                      conditionalClass: ['one', 'two', 'three', 'four', 'five', 'six'],
                      onOnChange: _ctx.handleOnChange,
                      onOnComplete: _ctx.handleOnComplete
                    }, null, 8, ["onOnChange", "onOnComplete"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t("transaction.resend_code_question")), 1),
                      _withDirectives(_createElementVNode("p", {
                        class: "resend ml-2 cursor-pointer",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onReTakeOtp && _ctx.onReTakeOtp(...args)))
                      }, _toDisplayString(_ctx.t("transaction.resend_code")), 513), [
                        [_vShow, _ctx.resendOtp.isEnd]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.t("user-login-page.label.resend")), 1),
                        _createTextVNode(" ( "),
                        _createVNode(_component_vue_countdown, {
                          class: "m-0",
                          ref: "countDownRef",
                          time: _ctx.resendOtp.time,
                          onEnd: _ctx.onOtpEnd
                        }, {
                          default: _withCtx(({ seconds }) => [
                            _createTextVNode(_toDisplayString(seconds) + "s ", 1)
                          ]),
                          _: 1
                        }, 8, ["time", "onEnd"]),
                        _createTextVNode(" ) ")
                      ], 512), [
                        [_vShow, !_ctx.resendOtp.isEnd]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_ion_button, {
                        disabled: _ctx.otpValidLength,
                        onClick: _ctx.handleConfirm
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("user-login-page.title.login")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ])
                  ]),
                  _: 1
                }, 512)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_modal_breakpoint, {
            title: _ctx.t('user-login-page.title.country'),
            trigger: "select-country",
            "initial-breakpoint": "0.7",
            ref: "modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_radio_group, {
                    modelValue: _ctx.countrySelected,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.countrySelected) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.country, (item, index) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: index,
                          onClick: _cache[4] || (_cache[4] = () => _ctx.handleSelectCountry(_ctx.countrySelected))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "d-flex" }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: require('@/common/assets/icon/profile/' + item?.flag)
                                }, null, 8, _hoisted_25),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(item?.name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_radio, {
                              slot: "start",
                              value: item.value
                            }, null, 8, ["value"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}